require('./angular-sanitize');
module.exports = 'ngSanitize';



//////////////////
// WEBPACK FOOTER
// /app/~/angular-sanitize/index.js
// module id = 4
// module chunks = 0